import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { FocusUtils } from "abreact/incubator/ui/utils/FocusUtils";
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbDecoratedTextInput } from "abreact/input/AbDecoratedTextInput";
import { AbSize, AbSizeContext, sizeProviderWrapper } from "abreact/misc/AbSize";
import * as AbWebResources from "abweb/generated/locale/AbWebResources";
import * as React from "react";
export function AbClearableTextInput(props) {
  const commonProps = ReactUtils.extractCommonProps(props);
  const {
    textInputCommonProps,
    buttonProps,
    value,
    onChange,
    ...textInputProps
  } = ReactUtils.extractNonCommonProps(props);
  const contextSize = React.useContext(AbSizeContext);
  const componentClassNames = ReactUtils.componentClassNamesString("ab-clearable-text-input", commonProps, [props.size ?? contextSize ?? AbSize.MEDIUM, props.readOnly && "ab-is-read-only"]);
  const textInputRef = React.useRef(null);
  const clearButtonProps = {
    ...buttonProps,
    tooltip: AbWebResources.clear(),
    icon: "absdk:clear-input",
    onClick: e => {
      if (buttonProps?.onClick !== undefined) buttonProps?.onClick?.(e);else props.onChange("");
      FocusUtils.setFocus(textInputRef.current?.inputElement);
    }
  };
  const decorators = props.value?.length > 0 && !props.readOnly && !props.disabled ? [clearButtonProps] : [];
  const inner = /*#__PURE__*/React.createElement(AbDecoratedTextInput, _extends({}, commonProps, {
    textInputProps: {
      ...textInputProps,
      ...textInputCommonProps,
      abRef: ReactUtils.mergeRefs(textInputRef, textInputProps.abRef)
    },
    value: value,
    onChange: onChange,
    className: componentClassNames,
    decorators: decorators
  }));
  return sizeProviderWrapper(inner, props, contextSize);
}
//# sourceMappingURL=AbClearableTextInput.js.map
